import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFontAwesome } from '@fortawesome/free-brands-svg-icons'
import router from './router'
import store from './store'
import VueCurrencyInput from 'vue-currency-input'
import "./styles/main.scss";
import { Datetime } from 'vue-datetime'

library.add(faUserSecret, faSpinner)
library.add(faFontAwesome)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false



import VuejsDialog from 'vuejs-dialog';
//import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'vue-datetime/dist/vue-datetime.css';

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.use(Datetime);

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: null, locale: 'pt-BR', autoDecimalMode: true, distractionFree: true, allowNegative: false, valueAsInteger: true }
}
Vue.use(VueCurrencyInput, pluginOptions)


import directives from "./directives/";
/**import { createApp } from "vue";
const app = createApp(App);
directives(app);
*/

Vue.directive(directives);

window._Vue = new Vue({
  router,
  store,
  //  directives,
  render: h => h(App)
}).$mount('#app')
